<section class="asset-charges glass-panel">
  <div class="wn-page-header">
    <div class="wn-page-title">
      <p class="eyebrow">{{ 'ASSETS.EYEBROW' | translate }}</p>
      <h1>{{ 'ASSET_CHARGES.TITLE' | translate }}</h1>
    </div>
    <div class="wn-page-actions">
      @if (canManage()) {
        <button type="button" pButton [outlined]="true" icon="pi pi-plus" class="asset-charges__new" [label]="'ASSET_CHARGES.NEW_PURCHASE' | translate" (click)="purchaseOpen.set(true)"></button>
      }
    </div>
  </div>

  <div class="asset-charges__toolbar">
    <label>
      <span class="asset-charges__filter-label">{{ 'ASSET_CHARGES.REASON_LABEL' | translate }}</span>
      <select id="asset-charges-reason" [value]="reason()" (change)="setReason($any($event.target).value)">
        <option value="">{{ 'ASSET_CHARGES.ALL_REASONS' | translate }}</option>
        @for (r of reasons; track r) {
          <option [value]="r">{{ 'ASSET_CHARGES.REASON.' + r | translate }}</option>
        }
      </select>
    </label>
    <label>
      <span class="asset-charges__filter-label">{{ 'ASSET_CHARGES.CHARGE_STATUS_LABEL' | translate }}</span>
      <select id="asset-charges-status" [value]="status()" (change)="setStatus($any($event.target).value)">
        <option value="">{{ 'ASSET_CHARGES.ALL_STATUSES' | translate }}</option>
        @for (s of statuses; track s) {
          <option [value]="s">{{ 'ASSET_CHARGES.STATUS.' + s | translate }}</option>
        }
      </select>
    </label>
    <div class="asset-charges__field asset-charges__employee">
      <span class="asset-charges__filter-label">{{ 'ASSET_CHARGES.EMPLOYEE' | translate }}</span>
      <app-user-lookup-select
        [value]="userId()"
        (valueChange)="setUser($event)"
        [placeholder]="'ASSET_CHARGES.SELECT_EMPLOYEE' | translate"
        [loadingLabel]="'ASSET_CHARGES.LOADING_EMPLOYEES' | translate"
        [emptyLabel]="'ASSET_CHARGES.NO_EMPLOYEE_MATCHES' | translate"
        [clearLabel]="'ASSET_CHARGES.CLEAR_EMPLOYEE' | translate"
      />
    </div>
    <button pButton type="button" [outlined]="true" [disabled]="loading()" [label]="'COMMON.RESET_FILTERS' | translate" (click)="resetFilters()"></button>
  </div>

  @if (error(); as err) {
    <p class="asset-charges__error" role="alert">{{ err }}</p>
  }

  @if (loading()) {
    <p class="asset-charges__status" role="status">{{ 'ASSET_CHARGES.LOADING' | translate }}</p>
  } @else if (!rows().length && !error()) {
    <wn-empty-state icon="pi pi-wallet" [title]="'ASSET_CHARGES.EMPTY' | translate" />
  } @else if (rows().length) {
    <div class="asset-charges__table-wrap">
      <table class="asset-charges__table">
        <thead>
          <tr>
            <th scope="col">{{ 'ASSET_CHARGES.EMPLOYEE' | translate }}</th>
            <th scope="col">{{ 'ASSET_CHARGES.REASON_LABEL' | translate }}</th>
            <th scope="col">{{ 'ASSET_CHARGES.ITEM' | translate }}</th>
            <th scope="col">{{ 'ASSET_CHARGES.TOTAL' | translate }}</th>
            <th scope="col">{{ 'ASSET_CHARGES.REMAINING' | translate }}</th>
            <th scope="col">{{ 'ASSET_CHARGES.STATUS_LABEL' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (row of rows(); track row.id) {
            <tr class="asset-charges__row">
              <td class="asset-charges__clamp" [attr.title]="row.userFullName || null">
                <a class="asset-charges__link" [routerLink]="['/assets/charges', row.id]">{{ row.userFullName || '-' }}</a>
              </td>
              <td>{{ 'ASSET_CHARGES.REASON.' + row.reason | translate }}</td>
              <td class="asset-charges__clamp" [attr.title]="row.itemDescription || assetLabel(row) || null">{{ row.itemDescription || assetLabel(row) || '-' }}</td>
              <td dir="ltr">{{ row.amount }}</td>
              <td dir="ltr">{{ row.remaining }}</td>
              <td><wn-status-chip [label]="'ASSET_CHARGES.STATUS.' + row.status | translate" /></td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }

  <wn-list-paginator [skip]="skip()" [pageSize]="pageSize()" [total]="totalCount()" [loading]="loading()" (pageChange)="changePage($event)" (pageSizeChange)="changePageSize($event)"></wn-list-paginator>

  @if (purchaseOpen()) {
    <app-purchase-charge-dialog (created)="onPurchaseCreated()" (closed)="purchaseOpen.set(false)" />
  }
</section>
